import { createModel } from "hox";
import React, { useState } from "react";
import { message } from "antd";
import { orgService } from "./OrgService";
import { OptModelTypeEnum } from "@components/YHDict/Types";
import { trasDsToTreeData } from "../dict/dictModel";
import { IMdOrgDetail } from "./OrgTypes";

export const useOrgModel = createModel(function () {
  const initDataSource: IMdOrgDetail[] = [];
  //列表数据源
  const [dataSource, setDataSource] = useState<IMdOrgDetail[]>(initDataSource);
  //表格选中行Key值
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedData, setSelectedData] = useState<IMdOrgDetail>();



  const [selectParentData, setSelectParentData] = useState<IMdOrgDetail>()
  const [optModelType, setOptModelType] = useState<OptModelTypeEnum>(OptModelTypeEnum.DETAIL)




  const getTreeData = () => {
    let treeData = trasDsToTreeData(dataSource, "code", "name");
    return treeData;
  }


  const loadData = async () => {
    let { retData } = await orgService.allTree({});
    setDataSource(retData);
  }
  const syncData = async () => {
    let ret = await orgService.sync({});
    ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
    ret && await loadData()
  }

  return {
    /***field***/
    dataSource,
    selectedRowKeys,
    selectedData,

    selectParentData,
    optModelType,

    /***method***/
    setDataSource,
    setSelectedRowKeys,
    getTreeData,
    loadData,
    syncData,
    setSelectedData,

    setSelectParentData,
    setOptModelType,
  }
});